<template>
  <PublicPopup
    ref="PopupRef"
    type="fullScreen"
    :height="90"
    position="bottom"
    :closeable="false"
    @close="emit('close')"
  >
    <template v-if="isIosOrAndroid == 'ios'" #content>
      <div class="download-guide-popup">
        <div class="header-container">
          <p class="title">Como usar PWA?</p>
          <van-icon name="close" class="close-icon" @click="handlePopupClose" />
        </div>

        <div class="content-card-title">
          <p class="title">1. Pulsa el boton Aniadirmenu</p>
        </div>
        <div class="content-card-images chxy-row-c-c">
          <img :src="getImageUrlWithCDN_LOCAL('/home/download_guide_1.webp', 'local')" class="images" />
        </div>

        <div class="content-card-title">
          <p class="title">2. Pulsa Anadir a la pantalla de inicio</p>
          <span class="content">
            En la lista mostrada, pulsa "Anadir a la pantalla de iniciopara completar la adicion. Si no encuentras el
            boton, prueba adesplazar la pantalla hacia abajo.
          </span>
        </div>
        <div class="content-card-images chxy-row-c-c">
          <img :src="getImageUrlWithCDN_LOCAL('/home/download_guide_2.webp', 'local')" class="images" />
        </div>
      </div>
    </template>
    <template v-else #content>
      <div class="download-guide-popup">
        <div class="header-container">
          <p class="title">Adicionar à tela inicial</p>
          <van-icon name="close" class="close-icon" @click="handlePopupClose" />
        </div>

        <div class="content-card-title">
          <p class="title">1. Toque no ícone "Mais" e, em seguida, toque em "Adicionar à tela principal"</p>
        </div>
        <div class="content-card-images chxy-row-c-c">
          <img :src="getImageUrlWithCDN_LOCAL('/home/guide_1.webp', 'local')" class="images" />
        </div>
        <div class="content-card-images chxy-row-c-c">
          <img :src="getImageUrlWithCDN_LOCAL('/home/guide_2_br.webp', 'local')" class="images" />
        </div>

        <div class="content-card-title">
          <p class="title">2. Clique em "Adicionar" e selecione "Adicionar"</p>
        </div>
        <div class="content-card-images chxy-row-c-c" style="position: relative">
          <img :src="getImageUrlWithCDN_LOCAL('/home/guide_3_br.webp', 'local')" class="images" />
          <div class="chxy-row-ac linshi">
            <img src="/theme/logo/logo.png" alt="logo" class="logo1" />
            <span class="app-name">{{ appName }}</span>
          </div>
        </div>
      </div>
    </template>
  </PublicPopup>
</template>

<script setup>
import { useDevice } from '@/utils/useDevice'
const PopupRef = ref(null)
const isIosOrAndroid = ref('')
const appName = ref('')
const { isIOS } = useDevice()
const open = () => {
  isIosOrAndroid.value = isIOS.value ? 'ios' : 'android'
  const localConfig = JSON.parse(localStorage.getItem('localConfig'))
  appName.value = localConfig?.appName || ''
  nextTick(() => {
    PopupRef.value.open()
  })
}
const handlePopupClose = () => {
  PopupRef.value.close()
}

const emit = defineEmits(['close'])

defineExpose({
  open,
})
</script>

<style lang="less" scoped>
.download-guide-popup {
  padding: 10px;
  width: 100%;
  height: 100%;
  background-color: var(--download-guide-popup-bg);
  overflow-y: scroll;

  .header-container {
    position: relative;
    width: 100%;
    height: 48px;
    font-size: 16px;
    text-align: center;
    line-height: 48px;

    .title {
      color: var(--popup-primary-title);
    }
    .close-icon {
      position: absolute;
      right: 10px;
      top: 50%;
      transform: translateY(-50%);
      font-size: 24px;
      color: var(--download-guide-popup-close-icon);
    }
  }

  .content-card-title {
    margin-top: 12px;

    .title {
      font-size: 14px;
      color: var(--download-guide-popup-content-label);
    }

    .content {
      font-size: 12px;
      color: var(--download-guide-popup-content-text);

      .web-name {
        color: var(--download-guide-popup-content-web);
      }
    }
  }

  .content-card-images {
    margin-top: 12px;

    .images {
      width: 90%;
    }
  }
}

.linshi {
  position: absolute;
  left: 70px;
  .logo1 {
    width: 40px;
    height: 40px;
    margin-right: 15px;
  }
  .app-name {
    font-size: 18px;
    font-weight: 500;
    width: 160px;
    color: #201e1ee3;
    height: 40px;
    line-height: 40px;
    border-bottom: 2px solid #2523235b;
  }
}
</style>
